<template>
	<div id="structure-view" style="display: block;">
		<div class="entry-view">
			<div 
				:style="
					$vuetify.breakpoint.mdAndDown
						? 'display: inline-block;'
						: 'display: block;'
				"
				style="
					position: relative;
					min-width: 100%;
					overflow: hidden;
				"
			>
				<img
					v-if="$root.isImage(structure.dataMap.backgroundLogin ? structure.dataMap.backgroundLogin : structure.background)"
					:src="$root.asset(structure.dataMap.backgroundLogin ? structure.dataMap.backgroundLogin : structure.background)"
					style="display: block;"
					:style="
						$vuetify.breakpoint.mdAndDown
							? 'height: 100vmax;'
							: 'width: 100vmax;'
					"
				/>
				<video
					v-else-if="$root.isVideo(structure.dataMap.backgroundLogin ? structure.dataMap.backgroundLogin : structure.background)"
					style="display: block;"
					:style="
						$vuetify.breakpoint.mdAndDown
							? 'height: 100vmax;'
							: 'width: 100vmax;'
					"
					muted
					playsinline
					disablepictureinpicture
					loop="loop"
				>
					<source :src="$root.asset(structure.dataMap.backgroundLogin ? structure.dataMap.backgroundLogin : structure.background)" type="video/mp4" />
				</video>
				<v-row class="mx-0" style="
						position: fixed;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
					">
					<v-col cols="12" class="d-flex justify-center align-center">
						<v-form ref="form" v-model="valid" @submit.prevent="initiateForgotPassword()">
							<v-card
								max-width="350"
								:style="
									$vuetify.breakpoint.smAndUp
										? 'width: 350px;'
										: 'width: 95vw;'
								"
								rounded="xl"
								class="mx-auto"
							>
								<v-card-title class="title d-flex justify-center align-center mb-4" style="color: white">
									<v-img v-if="structure.dataMap.logo" max-height="100" contain :src="
											$root.asset(structure.dataMap.logo)
										"></v-img>
								</v-card-title>
								<v-card-text v-if="!isSuccess">
									<v-text-field
										v-model="email"
										:rules="[
											(v) => !!v || 'E-mail is required',
											(v) =>
												/.+@.+\..+/.test(v) ||
												'E-mail must be valid',
										]"
										label="E-mail"
										dense
										rounded
										filled
										required
									></v-text-field>
									<v-row style="margin: 0" justify="end">
										<v-col cols="4" sm="4">
											<v-btn
												class="v-unite-primary"
												depressed
												rounded
												:to="'/' + tenantSlug +'/' + experienceSlug">Cancel</v-btn>
										</v-col>
										<v-col cols="8" sm="8">
											<v-btn :disabled="!valid" class="v-unite-primary" type="submit" min-width="150" depressed rounded block>Submit</v-btn>
										</v-col>
									</v-row>
								</v-card-text>
								<v-card-text v-else class="text-center">
									<h2 class="display-1">Reset password email has been sent</h2>
									<br />
									<p>
										Please check your email, follow the link
										and change your password.
									</p>
									<v-btn
										class="v-unite-primary"
										depressed
										rounded
										:to="
											'/' +
											tenantSlug +
											'/' +
											experienceSlug
										"
									>Back to login</v-btn>
								</v-card-text>
								<v-progress-linear rounded v-if="$root.loader.value" :indeterminate="$root.loader.value"></v-progress-linear>
								<div style="height: 20px"></div>
							</v-card>
						</v-form>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<style>
#structure-view .entry-view {
	overflow-x: auto;
	overflow-y: auto;
	width: auto;
	max-width: 100%;
	height: auto;
	margin: 0 auto;
}
.entry-view {
	/* position: relative; */
	margin: 0;
}
audio,
canvas,
progress,
video {
	display: inline-block;
	vertical-align: baseline;
}
</style>

<style scoped>
/* Let's get this party started */
::-webkit-scrollbar {
	height: 0px;
}
</style>

<script>
import axios from "axios";

export default {
	props: ["tenantSlug", "experienceSlug"],
	data() {
		return {
			dialog: true,
			valid: true,
			email: null,
			structure: { dataMap: {} },
			isSuccess: false,
			baseLocation: axios.defaults.baseURL
		};
	},
	mounted: function() {
		this.entrance();
	},
	methods: {
		entrance() {
			axios
				.get("/system/public/structure?tenantSlug=" + this.tenantSlug + "&experienceSlug=" + this.experienceSlug)
				.then(response => {
					this.structure = response.data;
				})
				.catch(() => {});
		},
		initiateForgotPassword() {
			axios
				.post("/system/authentication/resetpassword/initiate", {
					tenantSlug: this.tenantSlug,
					experienceSlug: this.experienceSlug,
					email: this.email
				})
				.then(response => {
					this.isSuccess = response.data;
					this.$refs.form.reset();
				})
				.catch(() => {});
		}
	}
};
</script>